import axios from "axios";
import {getAuthorization} from "./util.service";

export const ConfigAPIEndpoint = {
    JanusURL: "api/v1/config/get-config?key=SERVICES_JANUS_URL"
}

export const getVideoCallURL = () => {

}

export const setJanusServerURL = () => {
    let link = window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + ConfigAPIEndpoint.JanusURL
    console.log("setJanusServerURL")

    return new Promise((resolve, reject) => {
        axios
            .get(link, {
                // params: param,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: getAuthorization(),
                },
            })
            .then(function (response) {
                const url = new URL(response.data.value);
                if (url.port === "8088") {
                    url.port = "8089"
                }
                if (url.protocol === "http:") {
                    url.protocol = "https:"
                }
                sessionStorage.setItem('janusServerURL', url.toString());
                resolve(url.toString());
            })
            .catch(function (error) {
                reject(error);
            })
            .finally(function () {
                // always executed
            });
    })
}

export const getJanusServerURL = () => {
    // let envJanusServer = window.__RUNTIME_CONFIG__.REACT_APP_JANUS_SERVER;
    // console.log("envJanusServer", envJanusServer);
    // if (envJanusServer) return envJanusServer;
    let data = sessionStorage.getItem('janusServerURL');
    if (data) return data;

    let link = window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + ConfigAPIEndpoint.JanusURL

    return new Promise((resolve, reject) => {
        axios
            .get(link, {
                // params: param,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: getAuthorization(),
                },
            })
            .then(function (response) {
                const url = new URL(response.data.value);
                if (url.port === "8088") {
                    url.port = "8089"
                }
                if (url.protocol === "http:") {
                    url.protocol = "https:"
                }
                sessionStorage.setItem('janusServerURL', url.toString());
                resolve(url.toString());
            })
            .catch(function (error) {
                reject(error);
            })
            .finally(function () {
                // always executed
            });
    })
}
